export const navbarItems = [
  { name: "Home", link: "/dashboard", Selected: false },
  { name: "Gym", link: "/gym", Selected: false },
  { name: "Eat", link: "/mealdiet", Selected: false },
  { name: "Good read", link: "/good-read", Selected: false },
  { name: "Track", link: "/track/menu", Selected: false },
];
